import {CHESTS} from '../../constants/chests';
import {QUESTS} from '../../configs/quests';
import {getChestDisplayName} from '../inventory/getChestDisplayName';

export const LOCAL_MATCH_QUEST_ID = 'local_match_not_last';

// Сундук за первый бой с ботами: его обложку и имя показывает приглашение в
// главном меню (BotMatchPromoModal). Значение берется из самого задания —
// правка конфига не должна расходиться с обещанием в модалке
export const LOCAL_MATCH_QUEST_CHEST_ID = QUESTS
  .find((quest) => quest.id === LOCAL_MATCH_QUEST_ID)?.reward?.chestId
  || CHESTS.RANDOM_EPIC;

/**
 * Что игрок получит за задание «Сыграть матч против ботов» — для приглашения
 * в бой с ботами: награда там названа по имени, и она должна совпасть с тем,
 * что выдаст сервер. За уже выполненное задание награды нет.
 *
 * @param {string[]} [completedQuests] - id выполненных заданий из профиля
 * @returns {{type: 'chest', chestId: string, name: string}|null} null — награды не будет
 */
export const getLocalMatchQuestReward = (completedQuests = []) => {
  const quest = QUESTS.find((item) => item.id === LOCAL_MATCH_QUEST_ID);
  if (!quest?.reward || (completedQuests || []).includes(quest.id)) {
    return null;
  }

  return {
    type: 'chest',
    chestId: quest.reward.chestId,
    name: getChestDisplayName(quest.reward.chestId),
  };
};
